var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubscribeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.549988,
    width: 40,
    height: 40,
    rx: 8,
    fill: "#4649E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6346 10.55H25.7235L13.1525 22.4167C13.1052 22.55 13.0485 22.8522 13.1998 22.9944C13.351 23.1367 13.7039 23.0537 13.8614 22.9944C16.9805 20.15 23.266 14.3722 23.266 14.3722C23.266 14.3722 23.6021 14.141 23.8331 14.0167C25.0181 13.3788 25.9323 13.296 27.283 13.4833C28.9865 13.7195 30.0875 14.2828 31.0638 15.6167C31.9627 16.8449 32.1326 17.8731 31.9144 19.35C31.7427 20.5125 31.0638 21.6463 30.6384 22.1055C30.2131 22.5648 21.5647 30.55 21.5647 30.55H14.4285L26.905 18.8611C26.968 18.6685 26.9937 18.3477 26.7632 18.1944C26.5351 18.0428 26.1803 18.2241 26.0543 18.2833C23.2975 20.9352 17.7461 26.2478 17.5949 26.2833C17.4058 26.3278 17.3113 26.55 15.9408 27.35C14.8444 27.99 12.932 27.8537 12.1128 27.7055C11.3882 27.4537 10.0773 26.9763 9.22997 26.0167C8.22697 24.8807 8.04849 23.8389 8.00123 22.4167C7.96343 21.2789 8.80464 19.8981 9.22997 19.35L18.6346 10.55Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscribeIcon);
export default __webpack_public_path__ + "static/media/subscribeIcon.ef6a55a7b0e23484902c3ee2482670e7.svg";
export { ForwardRef as ReactComponent };